import { Badge, Text, Tooltip } from "@mantine/core"
import { FormulaResult } from "../../../../../../@client/Theasoft_ApiServer_Orchestra"

export function FormulaContractCell({
  formulaSum: v,
}: {
  formulaSum: FormulaResult
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "stretch",
        alignItems: "stretch",
      }}
    >
      {v.value ? <FormulaResultBadge value={v} /> : null}
    </div>
  )
}

const FormulaResultBadge = ({ value }: { value: FormulaResult }) => (
  <Badge
    radius={0}
    flex="1"
    fullWidth
    h="100%"
    variant="light"
    bg={value.bg}
    p={0}
    c={value.c}
  >
    <Tooltip label={value.text}>
      <Text size="xs">{value.value}</Text>
    </Tooltip>
  </Badge>
)
